import React from "react";

export default function SetupLayout({ children }) {
  return children;
}
